// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__115OM","left":"styles_left__3M8tp","desktopActions":"styles_desktopActions__2pO2z","title":"styles_title__3uoKU"};